// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"707d4304","413":"f241a8f7","688":"59365f71","706":"d29164da","736":"f78096f1"}[chunkId] + ".chunk.css";
};